/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PageStringSection } from "./pageStringSection";

export class MyProfile extends PageStringSection {
    button_assumeIdentity_label: string = "Labels.lbl_AssumeIdentity";
    button_revertIdentity_label: string = "Labels.lbl_RevertIdentity";
    button_search_placeholder: string = "Labels.lbl_Search";
    button_supportingText_search: string = "Messages.msg_Minimum3Characters";
    heading_identity: string = "Labels.lbl_Identity";
    heading_selectUser: string = "Labels.lbl_SelectUser";
    pageTitle: string = "Labels.lbl_MyProfile";
    text_assumeIdentity: string = "Messages.msg_AssumeIdentityDescription";
    text_department: string = "Labels.lbl_UserDepartment";
    text_emailAddress: string = "Labels.lbl_EmailAddress";
    text_fullName: string = "Labels.lbl_FullName";
    text_identityAssumed: string = "Messages.msg_IdentityAssumed";
    text_noUserFound: string = "Messages.msg_NoUserFound";
    text_location: string = "Labels.lbl_Location";
    text_practiceArea: string = "Labels.lbl_UserPracticeArea";
    text_profile: string = "Labels.lbl_UserProfile";
    text_phoneNumber: string = "Labels.lbl_PhoneNumber";
    text_title: string = "Labels.lbl_UserTitle";
    text_username: string = "Labels.lbl_LoginUserName";
}
